import { guessCurrencyFromCountry, normalizeCurrency, timezoneLabel } from './currency';

export async function detectInitialUserSettings() {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  const locale = navigator.language || 'en-US';
  let countryCode = locale.split('-')[1] || '';
  let currency = '';
  let currencyAutoDetected = false;

  try {
    const response = await fetch('https://ipapi.co/json/');
    if (response.ok) {
      const payload = await response.json();
      countryCode = String(payload?.country_code || countryCode || '').toUpperCase();
      currency = normalizeCurrency(payload?.currency || guessCurrencyFromCountry(countryCode, ''));
      currencyAutoDetected = Boolean(currency);
    }
  } catch {
    // Best-effort only.
  }

  if (!currency) {
    currency = guessCurrencyFromCountry(countryCode, '');
    currencyAutoDetected = Boolean(currency);
  }

  if (!currency) {
    if (timezone.includes('Edmonton') || timezone.includes('Calgary') || timezone.includes('Toronto') || timezone.includes('Vancouver')) currency = 'CAD';
    else if (timezone.includes('London')) currency = 'GBP';
    else if (timezone.includes('Tokyo')) currency = 'JPY';
    else if (timezone.includes('Sydney')) currency = 'AUD';
    else currency = 'USD';
  }

  return {
    currency: normalizeCurrency(currency),
    currencyAutoDetected,
    countryCode: String(countryCode || '').toUpperCase(),
    timezone,
    timezoneLabel: timezoneLabel(timezone),
  };
}
